import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import MainPage from './pages/MainPage';
import { ThemeProvider } from './context/ThemeContext';
import axios from 'axios';
import config from './config';

// 设置axios基础配置
axios.defaults.baseURL = config.API_BASE_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

// 添加超时配置和重试逻辑
axios.defaults.timeout = 30000; // 30秒超时

// 请求拦截器，添加Token并记录请求信息
axios.interceptors.request.use(config => {
  console.log('发送请求:', config.method?.toUpperCase(), config.url);
  const token = localStorage.getItem('accessToken');
  if (token) {
    console.log('包含Authorization头');
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// 响应拦截器，处理Token过期等错误
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        // Token过期，清除本地存储并跳转到登录页
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
      } else if (error.response.status === 400 && error.response.data && error.response.data.message) {
        // 对于400错误，如果有错误信息，将其传递给Promise rejection
        error.message = error.response.data.message;
      }
    }
    return Promise.reject(error);
  }
);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // 检查用户是否已认证
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        try {
          // 验证Token有效性
          const response = await axios.get('/auth/validate', {
            params: { token }
          });
          setIsAuthenticated(response.data.data);
        } catch (error) {
          setIsAuthenticated(false);
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
        }
      }
    };
    checkAuth();
  }, []);

  // 自定义受保护的路由组件
  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  return (
    <ThemeProvider>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginPage setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/" element={
            <ProtectedRoute>
              <MainPage setIsAuthenticated={setIsAuthenticated} />
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;